import { exp } from './dmath';

export const TAU = Math.PI * 2;

export const clamp = (v: number, min: number, max: number): number => (v < min ? min : v > max ? max : v);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const invLerp = (a: number, b: number, v: number): number => (a === b ? 0 : (v - a) / (b - a));

/** Moves `current` towards `target` by at most `maxDelta`. */
export const approach = (current: number, target: number, maxDelta: number): number =>
  current < target ? Math.min(current + maxDelta, target) : Math.max(current - maxDelta, target);

/** Wraps an angle into (-PI, PI]. */
export const wrapAngle = (a: number): number => {
  const w = a - TAU * Math.floor((a + Math.PI) / TAU);
  return w === -Math.PI ? Math.PI : w;
};

/** Shortest signed difference `b - a` between two angles. */
export const angleDiff = (a: number, b: number): number => wrapAngle(b - a);

export const lerpAngle = (a: number, b: number, t: number): number => a + angleDiff(a, b) * t;

export const length = (x: number, y: number): number => Math.sqrt(x * x + y * y);

/**
 * Frame-rate independent exponential smoothing: `damp(a, b, lambda, dt)` closes `1 - e^(-lambda*dt)` of
 * the gap. Use for cameras, UI followers, error decay.
 */
export const damp = (a: number, b: number, lambda: number, dt: number): number => lerp(a, b, 1 - exp(-lambda * dt));

export const sign = (v: number): -1 | 0 | 1 => (v > 0 ? 1 : v < 0 ? -1 : 0);
